import { useSearchItems } from 'services/Search/useSearchItems';

export const useSupportingItems = (campaignId: number) =>
  useSearchItems({ supportedCampaignId: campaignId, size: 12, sortType: 'RECENT' });
